export class CloseWarningDialog {
	static readonly type = '[Idle Timeout] Close Warning Dialog';
}

export class ResetIdleTimeoutFromWarningDialog {
	static readonly type =
		'[Idle Timeout] User Reset Idle Timeout From Warning Dialog';
}

export class Logout {
	static readonly type = '[Idle Timeout] Logout';
	constructor(public doNotNotify?: boolean) {}
}

export class OpenWarningDialog {
	static readonly type = '[Idle Timeout] Open Warning Dialog';
	constructor(public countdownSeconds: number) {}
}

export class UpdateLocalStorageActivityTimestamp {
	static readonly type =
		'[Idle Timeout] Update Local Storage Last Activity Timestamp';
	constructor(
		public lastActiveAt: number,
		public ignoreOpenedWarningDialog = false,
	) {}
}

export class UpdateStoreActivityTimestamp {
	static readonly type = '[Idle Timeout] Update Store Last Activity Timestamp';
	constructor(
		public lastActiveAt: number,
		public ignoreOpenedWarningDialog = false,
	) {}
}
